import sreejitaPic from "../../../Pictures/posts/SreejitaBiswas.jpg";
import aryanPic from "../../../Pictures/posts/aryan.jpg";
import srijanPic from "../../../Pictures/posts/Srijan.jpg";
import samaseenPic from "../../../Pictures/posts/samaseen.jpg";
import manojPic from "../../../Pictures/posts/Manoj.jpg";
import manojdokipic from "../../../Pictures/posts/manojdoki.jpg"
import namrataPic from "../../../Pictures/posts/namrata.jpg";
import sumitPic from "../../../Pictures/posts/sumit.jpg";
import vidyaPic from "../../../Pictures/posts/vidya.jpeg";
import tanmayPic from "../../../Pictures/posts/tanmay.jpg";
import ankitPic from "../../../Pictures/posts/ankit.jpeg";
import chandanPic from "../../../Pictures/posts/chandan.jpg";
import nabaPic from "../../../Pictures/posts/Naba.jpg";
import rituPic from "../../../Pictures/posts/ritu.jpg";
import naivedyamPic from "../../../Pictures/posts/Naivedyam.png";
import sureshPic from "../../../Pictures/posts/suresh.jpg";

export const TeamMembers = [
  // Organizer
  {
    name: "Sreejita",
    post: "Organizer",
    image: sreejitaPic,
  },
  {
    name: "Aryan",
    post: "Organizer",
    image: aryanPic,
  },

  // Chief Curator
  {
    name: "Srijan",
    post: "Chief Curator",
    image: srijanPic,
  },
  {
    name: "Samaseen",
    post: "Chief Curator",
    image: samaseenPic,
  },

  // Director of Marketing & Communications
  {
    name: "Vidya",
    post: "Director Of Marketing & Communications",
    image: vidyaPic,
  },
  {
    name: "Tanmay",
    post: "Director Of Marketing & Communications",
    image: tanmayPic,
  },

  // Director of Operations
  {
    name: "Naba",
    post: "Director Of Operations",
    image: nabaPic,
  },
  {
    name: "Ritu",
    post: "Director Of Operations",
    image: rituPic,
  },

  // Director of Design & Video Production
  {
    name: "Sumit",
    post: "Director Of Design & Video Production",
    image: sumitPic,
  },
  {
    name: "Manoj",
    post: "Director Of Design & Video Production",
    image: manojdokipic,
  },

  // Director of Technical Operations
  {
    name: "Naivedyam",
    post: "Director of Technical Operations",
    image: naivedyamPic,
  },
  {
    name: "Suresh",
    post: "Director of Technical Operations",
    image: sureshPic,
  },

  // Director of Finance
  {
    name: "Ankit",
    post: "Director Of Finance",
    image: ankitPic,
  },
  {
    name: "Chandan",
    post: "Director Of Finance",
    image: chandanPic,
  },

  // Executive Producer
  {
    name: "Manoj",
    post: "Executive Producer",
    image: manojPic,
  },
  {
    name: "Namrata",
    post: "Executive Producer",
    image: namrataPic,
  },
];
